import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import EmployeeReferral from "./index";
import { MODULE_EMPLOYEE_REFERRAL } from "variables/modules";
import { displayIcon } from "variables/icons";

const employeeReferralRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employee Referrals",
		basePath: "employee-referrals",
		mainComponent: <EmployeeReferral />,
	    layout: "/console",	   
	    icon: displayIcon('FileUser', 'icon-item'),
	    subTitle:"Employee Referral",
		level:5,
		moduleId: MODULE_EMPLOYEE_REFERRAL,
	}),
]

export default employeeReferralRoutes;